<script lang="ts" setup>
export interface CiHtmlWithComponentsProps {
  html: string;
}
const props = withDefaults(defineProps<CiHtmlWithComponentsProps>(), {});

const { compiler, extractComponentNames, loadComponent } = useCompiler();

const componentNames = extractComponentNames(props.html);

let components = [];

components = await Promise.all(
  componentNames.map(async (name: string) => ({
    name,
    component: await loadComponent(name),
  })),
);

const Content = compiler(
  props.html,
  Object.fromEntries(components.map(({ name, component }) => [name, component])),
);
</script>

<template>
  <Content />
</template>
